import * as tslib_1 from "tslib";
import deleteCategoryRow from '../actions/deleteCategoryRow';
import { computed } from 'mobx';
import { observer } from 'mobx-react';
import { IconButton } from 'office-ui-fabric-react/lib/Button';
import { isControlFeatureEnabled } from 'owa-controls-feature-flags';
import * as React from 'react';
import { isCategoryInFavorites, ToggleFavoriteButton, lazyAddFavoriteCategory, lazyRemoveFavoriteCategory, } from 'owa-favorites';
var styles = require('./CategoryRow.scss');
var CategoryIconBar = /** @class */ (function (_super) {
    tslib_1.__extends(CategoryIconBar, _super);
    function CategoryIconBar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onFavoriteClicked = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var removeFavoriteCategory, addFavoriteCategory;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!isCategoryInFavorites(this.props.id)) return [3 /*break*/, 2];
                        return [4 /*yield*/, lazyRemoveFavoriteCategory.import()];
                    case 1:
                        removeFavoriteCategory = _a.sent();
                        removeFavoriteCategory(this.props.id, 'CategoriesOptions');
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, lazyAddFavoriteCategory.import()];
                    case 3:
                        addFavoriteCategory = _a.sent();
                        addFavoriteCategory(this.props.id, 'CategoriesOptions');
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        return _this;
    }
    Object.defineProperty(CategoryIconBar.prototype, "isCategoryInFavorites", {
        get: function () {
            return isCategoryInFavorites(this.props.id);
        },
        enumerable: true,
        configurable: true
    });
    CategoryIconBar.prototype.render = function () {
        return React.createElement("div", { className: styles.iconBar }, this.renderActionIcons());
    };
    CategoryIconBar.prototype.renderActionIcons = function () {
        var _this = this;
        return [
            React.createElement(IconButton, { key: "delete", className: styles.categoryActionIcon, iconProps: { iconName: "Delete" /* Delete */ }, onClick: function () { return deleteCategoryRow(_this.props.id, _this.props.name); } }),
            isControlFeatureEnabled('tri-categories-advanced') && (React.createElement(ToggleFavoriteButton, { key: "favorites", isClickDisabled: this.props.isNewCategoryPending, isInFavorites: this.isCategoryInFavorites, iconStyles: styles.categoryActionIcon, onClick: this.onFavoriteClicked, animate: true, spinnerStyles: styles.spinnerContainer })),
        ];
    };
    tslib_1.__decorate([
        computed
    ], CategoryIconBar.prototype, "isCategoryInFavorites", null);
    CategoryIconBar = tslib_1.__decorate([
        observer
    ], CategoryIconBar);
    return CategoryIconBar;
}(React.Component));
export default CategoryIconBar;
//# sourceMappingURL=CategoryIconBar.js.map